import {
	Subscription,
	SubscriptionStatus,
	SubscriptionType,
} from 'domain/subscription/interfaces/Subscription';

export const isPayingCustomer = (
	subscriptions: Subscription[] = [],
	applicationIds?: string[],
) =>
	subscriptions.some(
		(subscription) =>
			subscription.status === SubscriptionStatus.Active &&
			subscription.type === SubscriptionType.Paid &&
			(!applicationIds ||
				applicationIds.some(
					(applicationId) =>
						applicationId in subscription.applicationPermissions,
				)),
	);
